import { Button, EmptyState } from '@chakra-ui/react'

interface ErrorStateProps {
  title?: string
  message?: string
  onRetry?: () => void
}

export function ErrorState({
  title = 'Inhalte konnten nicht geladen werden',
  message = 'Die angeforderten Daten stehen derzeit nicht zur Verfügung. Bitte versuchen Sie es erneut.',
  onRetry,
}: ErrorStateProps) {
  return (
    <EmptyState.Root>
      <EmptyState.Content>
        <EmptyState.Title>{title}</EmptyState.Title>
        <EmptyState.Description>{message}</EmptyState.Description>

        {onRetry && (
          <Button variant="outline" onClick={onRetry}>
            Erneut versuchen
          </Button>
        )}
      </EmptyState.Content>
    </EmptyState.Root>
  )
}
